import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Input as Select } from 'reactstrap';
import { Input } from 'core/components';

class GeneralInput extends Component {

	render() {
		const { options, ...other } = this.props;
		let selectOptions = options
			? Object.entries(options).map(([key, value]) => <option key={key} value={key}>{value}</option>)
			: undefined;

		if (selectOptions)
			return (
				<Select
					{...other}
					autoComplete="off"
					readOnly={this.props.readOnly || undefined}
				>
					<option value="">-----</option>
					{selectOptions}
				</Select>
			);

		return (
			<Input
				{...other}
				autoComplete="off"
				readOnly={this.props.readOnly || undefined}
			/>
		);
	}
}

GeneralInput.propTypes = {
	id: PropTypes.string,
	type: PropTypes.string.isRequired,
	required: PropTypes.bool,
	maxLength: PropTypes.number,
	name: PropTypes.string.isRequired,
	value: PropTypes.oneOfType([
		PropTypes.string,
		PropTypes.number,
		PropTypes.bool,
	]).isRequired,
	onChange: PropTypes.func,
	valid: PropTypes.string,
	readOnly: PropTypes.bool,
	options: PropTypes.oneOfType([
		PropTypes.object,
		PropTypes.array
	]),
};

export default GeneralInput;
